import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	Output,
} from '@angular/core';
import { DateTime } from 'luxon';

@Component({
	selector: 'calendar-header',
	templateUrl: './calendar-header.component.html',
	styleUrls: ['./calendar-header.component.scss'],
})
export class CalendarHeaderComponent implements OnChanges {
	@Input() mode = 'Week';
	@Output() changeActiveDate = new EventEmitter<Date>();
	@Input() activeDate;
	activeName = '';

	ngOnChanges(): void {
		this.activeName = this.getActiveName();
	}

	showCurrent() {
		this.changeActiveDate.emit(new Date());
	}

	changeDate(mode: 'previous' | 'next') {
		const comand = mode === 'previous' ? 'minus' : 'plus';
		let newActiveDate;
		const luxonActiveDate = DateTime.fromJSDate(this.activeDate.date);
		if (this.mode === 'Day') {
			newActiveDate = luxonActiveDate[comand]({ days: 1 }).toJSDate();
		} else if (this.mode === 'Week') {
			newActiveDate = luxonActiveDate[comand]({ week: 1 }).toJSDate();
		} else if (this.mode === 'Month') {
			newActiveDate = luxonActiveDate[comand]({ month: 1 }).toJSDate();
		}
		this.changeActiveDate.emit(newActiveDate);
	}

	getActiveName() {
		if (!this.activeDate) return;
		if (this.mode === 'Day') {
			return `${this.activeDate.day} de ${this.activeDate.monthFullName} de ${this.activeDate.year}`;
		} else if (this.mode === 'Month') {
			return `${this.activeDate.monthFullName} de ${this.activeDate.year}`;
		} else if (this.mode === 'Week') {
			return this.getWeekName();
		}
	}

	getWeekName() {
		const luxonActiveDate = DateTime.fromJSDate(this.activeDate.date);
		const startOfWeek = luxonActiveDate.startOf('week');
		const endOfWeek = luxonActiveDate.endOf('week');
		const startWeekFullName = this.capitalizeFirstLetter(
			startOfWeek.setLocale('pt-BR').toFormat('LLLL')
		);
		const endWeekFullName = this.capitalizeFirstLetter(
			endOfWeek.setLocale('pt-BR').toFormat('LLLL')
		);
		if (startOfWeek.year === endOfWeek.year) {
			if (startOfWeek.month === endOfWeek.month) {
				return startWeekFullName + ' de ' + startOfWeek.year;
			} else {
				return `${startWeekFullName}/${endWeekFullName} de ${startOfWeek.year}`;
			}
		} else {
			return `${startWeekFullName} de ${startOfWeek.year}/${endWeekFullName} de ${endOfWeek.year}`;
		}
	}

	capitalizeFirstLetter(string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	}
}
